import router from '@/modules/market/router'
import MarketApi from '@/modules/market/service'
import { useMarketStore } from '@/modules/market/store'
export default {
  store: useMarketStore,
  service: new MarketApi(),
  router,
}
